import { Input, Label } from "reactstrap";
import { TextareaAutosize } from "@material-ui/core";
import { RichEditComponent } from "../../../globals/core/Messaging/richEdit";
import styles from "./EmailComposer.module.scss";
import SelectField from "./SelectField";
import { LANGUAGES, MESSAGE_TYPES } from "./constants";

interface EmailComposerProps {
  message: {
    msgType: string;
    msgLanguage: string;
    msgTitle: string;
    msgBody: string;
  };
  updateMessage: (form: any) => void;
  onSend: () => void;
}

const EmailComposer = ({ message, updateMessage, onSend }: EmailComposerProps) => {
  const { msgType, msgLanguage, msgTitle, msgBody } = message || {};
  const isEmailType = msgType === "Email" || msgType === "EmailInvite";
  const isTextType = msgType === "Internal" || msgType === "Mobile";

  return (
    <div className={styles.container}>
      <div className={styles.header}>Communicate with our participants</div>
      <div className="d-flex gap-2">
        <SelectField
          label="Type"
          id="_msgtype"
          value={msgType}
          options={MESSAGE_TYPES}
          onChange={(e) => updateMessage({ msgType: e.target.value })}
        />
        <SelectField
          label="Language"
          id="_msglang"
          value={msgLanguage}
          options={LANGUAGES}
          onChange={(e) => updateMessage({ msgLanguage: e.target.value })}
        />
      </div>
      {msgType !== "Internal" && (
        <div>
          <Label className={styles.label} htmlFor="_title">
            {msgType === "Mobile" ? "Title" : "Subject"}
          </Label>

          <Input
            className={styles.input}
            value={msgTitle}
            placeholder="Title / Subject goes here"
            onChange={(e) => updateMessage({ msgTitle: e.target.value })}
            type="text"
            id="_title"
          />
        </div>
      )}
      {/* TODO move this to a separate component */}
      <div className="messagingBody">
        <Label className={styles.label} htmlFor="_messageBody">
          Message body
        </Label>
        {(isEmailType) && (
          <RichEditComponent msgType={msgType} msgLanguage={msgLanguage} onChange={(value) => updateMessage({ msgBody: value })} onSend={onSend} />
        )}
        {(isTextType) && (
          <>
            <TextareaAutosize
              style={{
                width: "100%",
                padding: "10px",
                fontSize: "16px",
                color: "#0A2540",
                backgroundColor: "#F7F8FA",
                border: "1px solid #ccc",
                borderRadius: "4px",
                lineHeight: 1.5,
                resize: "vertical",
                boxSizing: "border-box",
                overflow: "auto",
              }}
              minRows={10}
              maxLength={150}
              cols={120}
              value={msgBody}
              placeholder="Message body goes here, max 150 characters for mobile / internal notification"
              onChange={(e) => updateMessage({ msgBody: e.target.value })}
              id="_messageBody"
            />
            <button className="send-message-btn" onClick={onSend} disabled={msgBody?.length === 0}>
              Send Message
            </button>
          </>
        )}
      </div>
    </div>
  );
};



export default EmailComposer;